import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { UserService } from '../../dataServices/userService';
import { AzureLoggerService } from '../../services/azureLoggerService';
import { ResetPasswordPageModel } from './reset-password-page.model';
import { MismatchValidator } from '../../validators/mismatch.validator';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'self-ins-reset-password',
    templateUrl: './reset-password-page.component.html',
    styleUrls: ['./reset-password-page.component.scss'],
    standalone: false
})
export class ResetPasswordPageComponent {
    public passwordFormGroup = new FormGroup({});
    public newPassword: string = '';
    public confirmPassword: string = '';

    public disableButtons: boolean = false;

    private resetCode: string = '';

    constructor(
        private userService: UserService,
        private toastrService: ToastrService,
        private router: Router,
        private azureLoggerService: AzureLoggerService,
        private formBuilder: FormBuilder,
        private translateService: TranslateService,
        route: ActivatedRoute
    ) {
        route.queryParams.subscribe(params => {
            this.resetCode = params['code'];
        });

        this.passwordFormGroup = this.formBuilder.group({
            newPassword: ['', [Validators.required]],
            confirmPassword: ['', [Validators.required]]
        }, {
            validators: [
                MismatchValidator('newPassword', 'confirmPassword')
            ]
        });
    }

    public resetPassword() {
        if (this.newPassword !== this.confirmPassword) {
            return;
        }

        this.disableButtons = true;

        const requestModel = {
            resetCode: this.resetCode,
            password: this.newPassword
        } as ResetPasswordPageModel;

        this.userService
            .resetPassword(requestModel)
            .pipe(
                finalize(() => {
                    this.disableButtons = false;
                })
            )
            .subscribe(
                _ => {
                    this.translateService.get('resetPassword.success').subscribe((message: string) => {
                        this.toastrService.success(message);
                    });
                    setTimeout(() => this.router.navigate(['']), 1000);
                },
                _error => {
                    this.azureLoggerService.logException(_error);
                    this.translateService.get('resetPassword.error').subscribe((message: string) => {
                        this.toastrService.error(message);
                    });
                }
            );
    }

    public gotoHome() {
        this.router.navigate(['/coverage']);
    }
}